import { useState, useEffect } from "react";
import FlechaDerecha from "../../../assets/img/promocionBlustay/FlechaDerecha.png";
import FlechaIzquierda from "../../../assets/img/promocionBlustay/FlechaIzquierda.png";

const TiempoLimitado1 = () => {
    const [time, setTime] = useState({
        horas: 1,
        minutos: 59,
        segundos: 59,
    });

    useEffect(() => {
        const interval = setInterval(() => {
            setTime((prev) => {
                let { horas, minutos, segundos } = prev;

                if (segundos > 0) {
                    segundos -= 1;
                } else {
                    if (minutos > 0) {
                        minutos -= 1;
                        segundos = 59;
                    } else if (horas > 0) {
                        horas -= 1;
                        minutos = 59;
                        segundos = 59;
                    } else {
                        clearInterval(interval); // se acaba el tiempo
                    }
                }

                return { horas, minutos, segundos };
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    // función helper para formatear con 2 dígitos
    const format = (num: number) => String(num).padStart(2, "0");

    return (
        <div className="flex flex-col justify-start items-center 2xl:mt-48 lg:mt-36 md:mt-24 mt-14">
            <div className="mt-5 md:text-2xl xs:text-lg text-base font-semibold">
                Por tiempo limitado
            </div>
            <div className="bg-[#C3EA43] p-2 flex justify-center items-center gap-2 rounded-lg shadow-[6px_8px_12px_0px_rgba(0,_0,_0,_0.8)] w-3/4 mx-auto lg:mt-10 mt-2">
                <div className="flex flex-col justify-center items-center bg-white rounded-lg md:p-2 p-1.5 w-1/3">
                    <div className="text-3xl font-bold">
                        {format(time.horas)}
                    </div>
                    <div className="text-xs">Horas</div>
                </div>
                <div className="flex flex-col justify-center items-center bg-white rounded-lg md:p-2 p-1.5 w-1/3">
                    <div className="text-3xl font-bold">
                        {format(time.minutos)}
                    </div>
                    <div className="text-xs">Minutos</div>
                </div>
                <div className="flex flex-col justify-center items-center bg-white rounded-lg md:p-2 p-1.5 w-1/3">
                    <div className="text-3xl font-bold">
                        {format(time.segundos)}
                    </div>
                    <div className="text-xs">Segundos</div>
                </div>
            </div>
            <div className="flex flex-col justify-center items-center text-center md:mt-5 mt-3 w-5/6  mx-auto">
                <div className="flex justify-center items-center gap-2 mt-2 w-5/6 ">
                    <div className="uppercase md:text-4xl xs:text-3xl text-2xl text-[#029DE0] font-extrabold">
                        15 días de prueba
                    </div>
                    <div className="bg-[#029DE0] lg:w-10 lg:h-10 md:w-8 md:h-8 xs:w-7 xs:h-7 w-6 h-6 flex justify-center items-center rounded-full">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            className=" lg:w-8 lg:h-8 md:w-6 md:h-6 xs:w-5 xs:h-5 w-4 h-4 text-white"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M12 4.5v15m7.5-7.5h-15"
                            />
                        </svg>
                    </div>
                </div>

                <div className="flex justify-center items-center gap-2 w-5/6">
                    <div className="uppercase text-lg xs:text-xl md:text-2xl text-[#029DE0] font-extrabold text-center w-full ">
                        Demostración gratuita
                    </div>
                </div>

                <div className="w-full flex justify-between items-center md:mt-5 mt-3 md:w-4/5 ">
                    <img
                        src={FlechaIzquierda}
                        alt="izquierda"
                        className=" md:w-20 xs:w-16 w-14"
                    />
                    <div
                        onClick={() =>
                            window.open("https://wa.link/x9lq4l", "_blank")
                        }
                        className=" md:px-14 px-10 uppercase bg-[#029DE0] font-extrabold text-white rounded-full py-2 flex justify-center items-center gap-2 cursor-pointer hover:scale-105 md:text-lg xs:text-base text-sm transition"
                    >
                        Agenda Aquí
                    </div>

                    <img
                        src={FlechaDerecha}
                        alt="derecha"
                        className="md:w-24 xs:w-20 w-16"
                    />
                </div>
            </div>
        </div>
    );
};

export default TiempoLimitado1;
